import React from 'react';
import styles from './PackageFeatures.module.scss';
import useTranslation from 'hooks/useTranslation';

const PackageFeatures = ({ name, features }) => {
  const { getAppLocale } = useTranslation("");

  const selectedLocaleFeatures = features[getAppLocale()];

  return (
    <>
      <div className={styles.featureWrapper}>
        <ul>
          {selectedLocaleFeatures.map((feature) => (
            <li key={feature}>
              <div className={styles.iconWrapper}></div>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default PackageFeatures;
